// API Configuration
export const API_URL = process.env.API_URL || 'https://vieon-api.lumination.vn';

// Get the selected profile ID from localStorage
export const getSelectedProfileId = () => localStorage.getItem('selectedProfileId');

// Get the authenticated user data from localStorage
export const getAuthUser = () => {
  const authUser = localStorage.getItem('authUser');
  return authUser ? JSON.parse(authUser) : null;
};

// Get the user ID from localStorage
export const getUserId = () => {
  const authUser = getAuthUser();
  return authUser?.userId || null;
};

// Clear all authentication data
export const clearAuthData = () => {
  localStorage.removeItem('authUser');
  localStorage.removeItem('selectedProfileId');
};

// Check if user is authenticated
export const isAuthenticated = () => !!getAuthUser();

// Validate the current device's session against the server.
// Returns true if the session is still valid (or cannot be checked safely),
// false only when the server explicitly reports the session is invalid
// (i.e. the account was force-logged-out from all devices).
export const validateSession = async () => {
  const authUser = getAuthUser();

  // No user, or a legacy/mock user without a userId: nothing to validate.
  // We never force-logout in this case ("không tự ý logout").
  if (!authUser || !authUser.userId) {
    return true;
  }

  const sessionVersion = authUser.sessionVersion ?? 0;

  try {
    const response = await fetch(
      `${API_URL}/api/auth/session-status?user_id=${encodeURIComponent(
        authUser.userId
      )}&session_version=${encodeURIComponent(sessionVersion)}`,
      { headers: { accept: 'application/json' } }
    );

    // On network/server errors, fail open: keep the user logged in.
    if (!response.ok) {
      return true;
    }

    const data = await response.json();
    return data.valid !== false;
  } catch (err) {
    // Network failure: do not log the user out.
    return true;
  }
};

// Validate the session and, if the server says it is invalid, clear auth data.
// Returns true if still logged in, false if it just signed the device out.
export const enforceSession = async () => {
  const valid = await validateSession();
  if (!valid) {
    clearAuthData();
  }
  return valid;
};
